import { Context, Layer } from 'effect'

type AppFlagsService = {
  devMode: boolean
}

export class AppFlags extends Context.Service<AppFlags, AppFlagsService>()('AppFlags') {}

export function appFlagsLayer(flags: AppFlagsService) {
  return Layer.succeed(AppFlags, flags)
}
